import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import MenuPrincipal from '../views/MenuPrincipal.vue'
import Taller from '../views/Taller/Taller.vue'
import Logout from '../views/Logout.vue'
import PanelAhorro from '../views/DelAhorro/PanelAhorro'
import Pantallas from '../views/Pantallas/Contenido'

import cookie from 'vue-cookie'
import axios from 'axios'


Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Login', component: Login },

  { path: '/menuprincipal', name: 'MenuPrincipal', component: MenuPrincipal },

  { 
    path: '/taller', 
    name: 'Taller', 
    meta: { requiresAuth: true },
    component: Taller 
  },

  { path: '/logout', name: 'Logout', component: Logout },

  { path: '/home', name: 'Home', component: Home },  
  
  { 
    path: '/panelahorro', 
    name: 'PanelAhorro', 
    meta: { requiresAuth:true },
    component: PanelAhorro },  
  
  { 
    path: '/contenido', 
    name: 'Pantallas', 
    meta: { requiresAuth: true },
    component: Pantallas },  

  {
    path: '/surtac/recibomercancia', 
    name: "ReciboMercancia", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "ReciboMercancia" */ '../views/Surtace/ReciboMercancia')
  },

  {
    path: '/surtac/detallepedidorecpcion', 
    name: "DetallePedidoRecepcion", 
    meta: { requiresAuth: true},
    component: () => import(/* webpackChunkName: "ReciboMercancia" */ '../views/Surtace/DetallePedidoRecepcion')
  },

  {
    path: '/surtac/incidencias', 
    name: "Incidencias", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Incidencias" */ '../views/Surtace/Incidencias')
  },

  {
    path: '/surtac/PanelSeguimiento', 
    name: "PanelSeguimiento", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "PanelSeguimiento" */ '../views/Surtace/PanelSeguimiento')
  },

  {
    path: '/surtac/AltaClienteFrecuente', 
    name: "AltaClienteFrecuente", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "AltaClienteFrecuente" */ '../views/Surtace/ClienteFrecuenteAlta')
  },

  //Promociones
  {
    path: '/dipar/Promociones', 
    name: "Promociones", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Promociones" */ '../views/Dipar/Promociones')
  },

  {
    path: '/dipar/PromocionesReclamadas', 
    name: "Promociones Reclamadas", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Promociones Reclamadas" */ '../views/Dipar/PromocionesReclamadas')
  },

  {
    path: '/articulos/ImagenesArticulos', 
    name: "Imagenes Articulos", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Imagenes Articulos" */ '../views/Articulos/ImagenesArticulos')
  },

  {
    path: '/articulos/Shopify', 
    name: "Shopify", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Shopify" */ '../views/Shopify/Shopify')
  },

  {
    path: '/boletos/Boletos', 
    name: "Boletos", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Boletos" */ '../views/Boletos/Boletos')
  },
  
  {
    path: '/cambiodeprecios',
    name: "Cambio de Precios",
    meta: { requiresAuth: true},
    component: () => import(/* webpackChunkName: "Imagenes Articulos" */ '../views/Articulos/CambioPrecios' )
  },

  {
    path: '/sorteos/DetalleSorteo', 
    name: "Detalle Sorteo", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Detalle Sorteo" */ '../views/Sorteos/DetalleSorteo')
  },


  //Sistemas
  {
    path: '/sistemas/menu', 
    name: "MenuSistemas",
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "MenuSistemas" */ '../views/Sistemas/MenuSistemas'),
  },
  {
    path: '/sistemas/WMS', 
    name: "WMS", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "WMS" */ '../views/Sistemas/wms')
  },

  {
    path: '/sistemas/usuarios', 
    name: "Usuarios", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Usuarios" */ '../views/Sistemas/Usuarios')
  },


  //Compras web
  {
    path: '/comprasweb/Compra',
    name: "Compras Web", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Compras Web" */ '../views/ComprasWeb/Compra'),
  },

  //Compras cedis
  {
    path: '/comprascedis/CompraCedis', 
    name: "Compras Cedis", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Compras Cedis" */ '../views/ComprasWeb/CompraCedis')
  },

  //Catálogo artículos
  {
    path: '/articulos/catalogo',
    name: "CatalogoArticulos", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Catálogo Artículos" */ '../views/Articulos/Catalogo'),
  },
 
  //Bancos
  {
    path: '/bancos/factoraje',
    name: "Factoraje", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Factoraje" */ '../views/Bancos/Factoraje'),
  },

  //Clientes
  {
    path: '/clientes/analisisclientes',
    name: "AnalisisClientes", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "AnalisisClientes" */ '../views/Clientes/AnalisisClientes'),
  },

  //Reportes
  {
    path: '/reportes',
    name: "Reportes", 
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "Reportes" */ '../views/Reportes/Reportes.vue'),
  },


  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {

    if (to.matched.some((record) => record.meta.requiresAuth)) {
      
        const de = to.name
		let ruta = ''

		if(de == 'MenuSistemas' || de == 'WMS' || de == 'Usuarios'){	
			ruta = 'SISTEMAS'			
		}

    if(de == 'PanelAhorro'){
      ruta = 'AHORRO APP'
    }

		if(de == 'Taller'){
			ruta = 'TALLER'
		}

		if(de == 'Pantallas'){
			ruta = 'PANTALLAS'
		}

		if(de == 'ReciboMercancia' || de  == 'DetallePedidoRecepcion'){
			ruta = 'RECEPCIÓN'
		}

		if(de == 'Incidencias'){
			ruta = 'INCIDENCIAS'
		}

		if(de == 'PanelSeguimiento'){
			ruta = 'SEGUIMIENTO'
		}

		if(de == 'AltaClienteFrecuente'){
			ruta = 'ALTA CLIENTE FRECUENTE'
		}

		if(de == 'Promociones'){
			ruta = 'PROMOCIONES'
		}

		if(de == 'Promociones Reclamadas'){
			ruta = 'PROMOCIONES RECLAMADAS'
		}

		if(de == 'Imagenes Articulos'){
			ruta = 'IMÁGENES DE ARTÍCULOS'
		}

		if(de == 'Shopify'){
			ruta = 'SHOPIFY'
		}

    if(de == 'Cambio de Precios'){
      ruta = 'CAMBIO DE PRECIOS'
    }    

    if(de == 'Detalle Sorteo'){
      ruta = 'SORTEOS'
    }

    if(de == 'Compras Web'){
      ruta = 'COMPRAS WEB'
    }

    if(de == 'Compras Cedis'){
      ruta = 'COMPRAS CEDIS'
    }

    if(de == 'Boletos'){
      ruta = 'BOLETOS'
    }

    if(de == 'CatalogoArticulos'){
      ruta = 'CATÁLOGO'
    }

    if(de == 'Factoraje'){
      ruta = 'FACTORAJE'
    }

    if(de == 'AnalisisClientes'){
      ruta = 'ANALISIS CLIENTES'
    }

    if(de == 'Reportes'){
      ruta = 'REPORTES'
    }


		const token = cookie.get('token')
		axios.post(Vue.prototype.$url+'/token/validar',{"path":ruta}, {headers:{Authorization:`Bearer ${token}`}})
			.then((response)=>{
				next()
			})
			.catch((error)=>{
        console.log(error.response);
				console.log("Error al validar token ");
		
				if(error.response.statusText === 'Unauthorized'){
					// this.$router.push({name:'Logout'})
					next("/Logout")
				}
				if(error.response.statusText === 'Forbidden'){
					// this.$router.push({name:'MenuPrincipal'})
					next("/MenuPrincipal")
				}
			})


    }
    else {    

      next();
    }   
  
});


export default router
